// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ShineMagic from '../_raw/ui/icon_shine_magic.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ShineMagic);
